module.exports = __webpack_public_path__ + "8dac7dd3bcb0cef3c91a3396d802d860.svg";